import { FC } from "react"


interface PaginaLogoIntelbrasPropostaSimplificadaProps {
    logo: string;
    children?: React.ReactNode;
    pagina?: number;
    addBottom?: boolean;
    first?: boolean
}

const PaginaLogoIntelbrasPropostaSimplificada: FC<PaginaLogoIntelbrasPropostaSimplificadaProps> = ({ first = false, logo, children, pagina, addBottom }) => {
    return (
        <>
            {!first && <div className="page-break" />}

            <div className="page">
                <div className="page-header">
                    {logo ? (
                        <img src={logo} className="image-logo-intelbras" alt="Logo Intelbras" />
                    ) : null}
                </div>
                {children}
            </div >
        </>
    );
};

export default PaginaLogoIntelbrasPropostaSimplificada;